import styled, { css } from "styled-components";
import overlayAnimation from "../../../animations/overlayAnimation";
import { slideInVertical } from "../../../animations/slideIn";
import PushStyles from "../../../helpers/PushStyles";
import { animationDuration, pageGutterSpace, zIndex } from "../../../settings";
import breakpoint from "../../../utils/breakpoint";
import getBorderRadius from "../../../utils/getBorderRadius";
import getColor from "../../../utils/getColor";
import isNotEmpty from "../../../utils/isNotEmpty";
import isObject from "../../../utils/isObject";
import space from "../../../utils/space";
import Picture from "../../quarks/Picture";
import { modalBackgroundColor, modalBreakpointValue } from "./common";
export var Overlay = styled.div.withConfig({
  componentId: "sc-nvvsj7-0"
})(function (_ref) {
  var theme = _ref.theme;
  return css(["display:flex;position:fixed;z-index:", ";top:0;right:0;bottom:0;left:0;align-items:center;justify-content:center;padding:", ";animation:", " ", "s forwards;"], zIndex.ModalOrg, space(pageGutterSpace), overlayAnimation(theme), animationDuration.slow / 1000);
});
export var Container = styled.div.withConfig({
  componentId: "sc-nvvsj7-1"
})(function (_ref2) {
  var theme = _ref2.theme;
  return css(["position:relative;width:100%;max-width:", ";max-height:calc(100vh - ", ");overflow:hidden;animation:", " ", "s forwards;border-radius:", ";background-color:", ";", "{display:flex;align-items:center;}"], space(90), space(2 * pageGutterSpace), slideInVertical(), animationDuration.slow / 1000, getBorderRadius(theme, "large"), getColor(theme, modalBackgroundColor), breakpoint(modalBreakpointValue));
});
var getPaddingSpaceStyles = function getPaddingSpaceStyles(paddingSpace) {
  return css(["", " ", ""], typeof paddingSpace === "number" && css(["padding:", ";"], space(paddingSpace)), isObject(paddingSpace) && css(["", ";"], PushStyles(paddingSpace, true, "space", "padding")));
};
export var ContentWrapper = styled.div.withConfig({
  componentId: "sc-nvvsj7-2"
})(function (_ref3) {
  var $paddingSpace = _ref3.$paddingSpace;
  return css(["padding:", ";", "{flex-grow:1;", "}"], space(4), breakpoint(modalBreakpointValue), isNotEmpty($paddingSpace) ? getPaddingSpaceStyles($paddingSpace) : "padding: ".concat(space(7)));
});
export var MobileImageWrapper = styled.div.withConfig({
  componentId: "sc-nvvsj7-3"
})(["height:", ";"], space(15));
export var LargeImageWrapper = styled.div.withConfig({
  componentId: "sc-nvvsj7-4"
})(["flex-shrink:0;align-self:stretch;width:", ";"], space(30));
export var StyledImage = styled(Picture).withConfig({
  componentId: "sc-nvvsj7-5"
})(["width:100%;height:100%;object-fit:cover;"]);